// extracted by mini-css-extract-plugin
export default {"root":"loader_root__3qscC","loader_root":"loader_loader_root__xm99e","label":"loader_label__t52hS"};